<template>
  <div class="predefined transmit-document">TRANSMIT_DOCUMENT</div>
</template>

<script>
export default {
  name: 'TransmitDocument',
};
</script>

<style lang="scss" scoped></style>
